export default __webpack_public_path__ + "static/media/BrakeMaintenance1.0b9281e4.png";